import { useState } from "react";
import { useRouter } from "next/router";
import { IUseSelectRoleCard } from "./select-role-card.types";

import { UserType } from "types/common/common.types";
import { useAuth } from "stores/auth/auth-context";
import trackEvent from "services/mixpanel/mixpanel";
import { webCheckoutEventNames } from "services/mixpanel/web-checkout-events";
import { createPayloadForWebCheckoutTrackingEvent } from "utils/mixpanel/web-checkout/web-checkout-mixpanel-utils";

export const useSelectRole = (): IUseSelectRoleCard => {
  const router = useRouter();
  const { user } = useAuth();

  const [isSelected, setIsSelected] = useState({
    isStudent: false,
    isParent: false
  });

  const handleChange = (userType: UserType) => {
    const payload = createPayloadForWebCheckoutTrackingEvent({
      useAuthData: user,
      Class: true,
      level: true,
      packageType: null,
      tenureValue: null,
      stage: null
    });
    trackEvent({
      eventName: webCheckoutEventNames.userSelectedOnUserType,
      payload
    });

    if (userType === UserType.PARENT) {
      setIsSelected({ isStudent: false, isParent: !isSelected.isParent });
    }

    if (userType === UserType.STUDENT) {
      setIsSelected({ isParent: false, isStudent: !isSelected.isStudent });
    }
  };

  const handleRouteChange = () => {
    const userType = isSelected.isParent ? UserType.PARENT : UserType.STUDENT;

    user.setUserData({ ...user.userData, userType });
    router.push({
      pathname: "/user/add-user",
      query: router.query
    });
  };

  return {
    handleChange,
    handleRouteChange,
    isSelected
  };
};
